const actions = {
    Get: "VALIDEXTENSION.GET",
    Got: "VALIDEXTENSION.GOT",
    GetErrored: "VALIDEXTENSION.ERRORED"
};

module.exports = actions;


// WEBPACK FOOTER //
// ./src/actions/ValidExtensionActions.js